import axios from '@/plugins/AxiosExtension'

export default {
}